import { render, staticRenderFns } from "./ManagementDashboard.vue?vue&type=template&id=d6fa99f4&"
import script from "./ManagementDashboard.vue?vue&type=script&lang=ts&"
export * from "./ManagementDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports